import React from "react";
import Select from "react-select";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import { Loader } from "../common";
import Pagination from "react-js-pagination";
import {
  getStudentList,
  createNewStudent,
  updateCurrentStudentData,
  getMembershipDetails,
} from "../../actions";
import { convertToCurrencyFormat, isMobileDevice } from "../../helpers/Utils";
import AddStudent from "./addStudent";
import StyleConstants from "../../shared/constants/styleConstants/styles";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const IS_MOBILE = isMobileDevice();

const customDropdownStyles = {
  control: (base) => ({
    ...base,
    height: 35,
    width: 200,
    backgroundColor: "white",
    border: "1px solid #CDCFD6",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 35,
  }),
  valueContainer: (base) => ({
    ...base,
    height: 35,
    overflow: "auto",
  }),
  option: (base, state) => ({
    ...base,
    textAlign: "left",
    color: state.isFocused ? "#FFF" : "#000",
    backgroundColor: state.isFocused && "#3994AE",
  }),
};

const sortByValues = [
  { value: 3, label: "Fee Due: High to Low" },
  { value: 2, label: "Fee Due: Low to High" },
  { value: 0, label: "Name: Ascending" },
  { value: 1, label: "Name: Descending" },
];

class StudentList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      perPage: 10,
      selectedCampus: null,
      selectedClassroom: null,
      searchText: "",
      sortBy: sortByValues[0],
      hasAccess: true,
      showModal: false,
      student: null,
      selectedInstitutesTags: [],
    };
    this.newStudentDetails = this.newStudentDetails.bind(this);
    this.downloadExcel = React.createRef();
  }

  componentDidMount() {
    const {
      searchText,
      selectedCampus,
      selectedClassroom,
      selectedInstitutesTags,
      sortBy,
      page,
      perPage,
    } = this.state;
    this.setState({ hasAccess: true });
    this.props.getMembershipDetails();
    this.props
      .getStudentList(
        searchText,
        selectedCampus,
        selectedClassroom,
        selectedInstitutesTags,
        sortBy.value,
        page,
        perPage
      )
      .then((data) => {
        this.setState({ hasAccess: data.success });
      });
  }

  onFilterChange() {
    const {
      selectedCampus,
      selectedClassroom,
      searchText,
      sortBy,
      perPage,
      selectedInstitutesTags,
    } = this.state;
    this.setState({ page: 1 });
    this.props.getStudentList(
      searchText,
      selectedCampus,
      selectedClassroom,
      selectedInstitutesTags,
      sortBy.value,
      1,
      perPage
    );
  }

  renderSingleSelect(options, selectedOption, placeholder, key) {
    return (
      <Select
        value={selectedOption}
        onChange={(option) => {
          let updatedState = { [key]: option, page: 1 };
          if (key === "selectedCampus") {
            updatedState.selectedClassroom = null;
          }
          this.setState(updatedState, () => {
            this.onFilterChange();
          });
        }}
        options={options}
        placeholder={placeholder}
        styles={customDropdownStyles}
        isSearchable
        isClearable={key === "sortBy" ? false : true}
      />
    );
  }

  renderMultiSelect(options, selectedOption, placeholder, key) {
    return (
      <Select
        value={selectedOption}
        onChange={(option) => {
          let updatedState = { [key]: option, page: 1 };
          this.setState(updatedState, () => {
            this.onFilterChange();
          });
        }}
        options={options}
        placeholder={placeholder}
        styles={customDropdownStyles}
        isSearchable
        isMulti
        isClearable={key === "sortBy" ? false : true}
      />
    );
  }

  newStudentDetails(
    studentName,
    studentId,
    studentMobile,
    studentEmail,
    classroomId,
    currentStatus,
    classroomName,
    studentCampus,
    courseId,
    fatherName,
    fatherPhone,
    dob,
    fatherEmail,
    motherName,
    motherPhone,
    motherEmail,
    address,
    bloodGroup,
    doj,
    studentSelectedElectives,
    selectedInstitutesTags,
    isHostelite
  ) {
    this.props.createNewStudent(
      studentName,
      studentId,
      studentMobile,
      studentEmail,
      classroomId,
      classroomName,
      studentCampus,
      courseId,
      currentStatus,
      fatherName,
      fatherPhone,
      dob,
      fatherEmail,
      motherName,
      motherPhone,
      motherEmail,
      address,
      bloodGroup,
      doj,
      studentSelectedElectives,
      selectedInstitutesTags,
      isHostelite
    );
  }

  renderFilters() {
    const { campuses, classrooms, institutesTags } = this.props;
    const {
      selectedCampus,
      selectedClassroom,
      searchText,
      sortBy,
      selectedInstitutesTags,
    } = this.state;
    return (
      <>
        <div
          style={{ margin: 15, width: 100 }}
          className="Button Primary-Button"
          onClick={() => this.setState({ student: "new", showModal: true })}
        >
          New Student
        </div>
        <div
          style={{
            margin: 15,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              style={{ height: 25, width: 200, marginRight: 15 }}
              placeholder="Parent phone / Login No / Name"
              value={searchText}
              onChange={(event) => {
                this.setState(
                  {
                    searchText: event.target.value,
                  },
                  () => {
                    this.onFilterChange();
                  }
                );
              }}
              autoFocus
            ></input>
          </div>
          {campuses.length > 1 ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginRight: 15 }}>
                {this.renderSingleSelect(
                  campuses,
                  selectedCampus,
                  "Select Campus",
                  "selectedCampus"
                )}
              </div>
            </div>
          ) : (
            this.setState({ selectedCampus: campuses[0] })
          )}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: 15,
            }}
          >
            {this.renderSingleSelect(
              selectedCampus
                ? classrooms.filter(
                    (classroom) => classroom.campus_id === selectedCampus.value
                  )
                : classrooms,
              selectedClassroom,
              "Select Classroom",
              "selectedClassroom"
            )}
          </div>
          {institutesTags.length > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginRight: 15 }}>
                {this.renderMultiSelect(
                  institutesTags,
                  selectedInstitutesTags,
                  "Tags",
                  "selectedInstitutesTags"
                )}
              </div>
            </div>
          )}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "right",
            }}
          >
            {this.renderSingleSelect(sortByValues, sortBy, "Sort By", "sortBy")}
          </div>
        </div>
      </>
    );
  }

  renderStudentList() {
    const {
      page,
      perPage,
      searchText,
      selectedCampus,
      selectedClassroom,
      selectedInstitutesTags,
      sortBy,
    } = this.state;
    const {
      students,
      filteredStudentsLength,
      userDetails,
      totalFeeDue,
      totalFeePaid,
    } = this.props;
    if (this.props.isLoading) {
      return <Loader />;
    }
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              color: StyleConstants.color.darkBlue,
              margin: "auto 10px auto 0",
              paddingTop: "10px",
            }}
          >
            Total Number of Students: {filteredStudentsLength}
          </div>
          <div
            style={{
              fontWeight: "bold",
              color: StyleConstants.color.darkBlue,
              margin: "auto 10px auto 0",
              paddingTop: "10px",
            }}
          >
            Total Fee Paid: {convertToCurrencyFormat(totalFeePaid || 0)}
          </div>
          <div
            style={{
              fontWeight: "bold",
              color: StyleConstants.color.darkBlue,
              margin: "auto 10px auto 0",
              paddingTop: "10px",
            }}
          >
            Total Fee Due: {convertToCurrencyFormat(totalFeeDue || 0)}
          </div>
          {!(
            !userDetails.permissions?.includes("Admin") &&
            !userDetails.permissions?.includes("Finance Admin")
          ) && (
            <div
              className="Button Primary-Button"
              onClick={() =>
                this.props.history.push("/view_changes_to_payments")
              }
            >
              <span style={{ margin: "0 5px" }}>
                View payments change history
              </span>
            </div>
          )}
        </div>
        {filteredStudentsLength === 0 ? (
          <div style={{ textAlign: "center", margin: 50 }}>
            No students found, please try changing filters
          </div>
        ) : (
          <>
            <table
              className="table table-bordered"
              style={{ margin: "15px 0px 50px 0px" }}
            >
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Father's Name</th>
                  <th>Campus</th>
                  <th>Classroom</th>
                  <th style={{ textAlign: "right" }}>Fee Paid</th>
                  <th style={{ textAlign: "right" }}>Fee Due</th>
                </tr>
              </thead>
              <tbody>
                {students.map((student, index) => (
                  <>
                    <tr
                      key={student.membership_id}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.props.history.push(
                          `/fee_collection?id=${student.membership_id}`
                        )
                      }
                    >
                      <td style={{ textAlign: "right" }}>
                        {(page - 1) * 10 + (index + 1)}
                      </td>
                      <td>{student.first_name}</td>
                      <td>{student.father_name}</td>
                      <td>{student.campus_name}</td>
                      <td>{student.classroom_name}</td>
                      <td style={{ textAlign: "right" }}>
                        {convertToCurrencyFormat(student.amount_paid)}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {student.balance < 0
                          ? convertToCurrencyFormat(0)
                          : convertToCurrencyFormat(student.balance)}
                      </td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>

            <Pagination
              activePage={page}
              itemsCountPerPage={perPage}
              totalItemsCount={filteredStudentsLength}
              pageRangeDisplayed={IS_MOBILE ? 3 : 5}
              onChange={(pageNumber) => {
                this.setState({ page: pageNumber });
                this.props.getStudentList(
                  searchText,
                  selectedCampus,
                  selectedClassroom,
                  selectedInstitutesTags,
                  sortBy.value,
                  pageNumber,
                  perPage
                );
              }}
            />
          </>
        )}
      </div>
    );
  }

  renderDownload() {
    const { exportStudents } = this.props;
    const students = exportStudents?.map((student, index) => {
      return { ...student, index: index + 1 };
    });
    return (
      <div>
        <div
          className="Button Primary-Button"
          style={{
            marginLeft: 20,
            width: 100,
            fontWeight: "normal",
            fontFamily: "'Poppins', sans-serif",
            padding: "0 5px",
            float: "right",
          }}
          onClick={async () => {
            const {
              selectedCampus,
              selectedClassroom,
              searchText,
              sortBy,
              perPage,
              selectedInstitutesTags,
            } = this.state;
            await this.props.getStudentList(
              searchText,
              selectedCampus,
              selectedClassroom,
              selectedInstitutesTags,
              sortBy.value,
              1,
              perPage,
              true
            );
            this.downloadExcel.current.click();
          }}
        >
          {" "}
          Download .xls
        </div>
        <ExcelFile
          filename="Student Details"
          element={<div ref={this.downloadExcel}></div>}
        >
          <ExcelSheet data={students} name="Students">
            <ExcelColumn label="S.No" value="index" />
            <ExcelColumn label="Name" value="first_name" />
            <ExcelColumn label="Student Id" value="badge_id" />
            <ExcelColumn label="Father's Name" value="father_name" />
            <ExcelColumn label="Father's Phone" value="father_phone" />
            <ExcelColumn label="Campus" value="campus_name" />
            <ExcelColumn label="Classroom" value="classroom_name" />
            <ExcelColumn label="Fee Paid" value="amount_paid" />
            <ExcelColumn label="Fee Due" value="balance" />
          </ExcelSheet>
        </ExcelFile>
      </div>
    );
  }

  renderScreen() {
    return (
      <>
        {this.renderFilters()}
        {this.renderStudentList()}
        {this.props.students?.length !== 0 &&
          this.renderDownload()}
      </>
    );
  }

  noPermission() {
    return (
      <div
        style={{
          paddingTop: 200,
          paddingLeft: 300,
          width: "100%",
          backgroundColor: "#F5F8FA",
          fontSize: "20px",
        }}
      >
        <span style={{ borderStyle: "solid", padding: "10px" }}>
          {this.props.isLocked
            ? "Your Account has been locked."
            : "You dont have permission to access Payments"}
        </span>
      </div>
    );
  }

  render() {
    const { hasAccess } = this.state;
    return (
      <div style={{ padding: 50 }}>
        {hasAccess ? this.renderScreen() : this.noPermission()}
        {this.state.showModal && (
          <AddStudent
            showModal={this.state.showModal}
            handleCloseModal={() =>
              this.setState({ showModal: false, student: "" })
            }
            newStudentDetails={this.newStudentDetails}
            student={this.state.student}
            campuses={this.props.campuses}
            classrooms={this.props.classrooms}
            courses={this.props.courses}
            departments={this.props.departments}
            electives={this.props.electives}
            institutesTags={this.props.institutesTags}
            institutesTagGroups={this.props.institutesTagGroups}
            isHigherEducationInstitute={this.props.isHigherEducationInstitute}
          />
        )}
      </div>
    );
  }
}

StudentList.propTypes = {
  isLoading: PropTypes.bool,
  campuses: PropTypes.array,
  classrooms: PropTypes.array,
  students: PropTypes.array,
  institutesTags: PropTypes.array,
  filteredStudentsLength: PropTypes.number,
  userDetails: PropTypes.object,
  institutesTags: PropTypes.array,
  institutesTagGroups: PropTypes.array,
};

StudentList.defaultProps = {
  campuses: [],
  classrooms: [],
  students: [],
  institutesTags: [],
  isLoading: false,
  filteredStudentsLength: 0,
  institutesTags: [],
  institutesTagGroups: [],
};

const mapStateToProps = ({ home, student, auth }) => ({
  isLoading: student.isLoading,
  campuses: home.campuses,
  students: student.students,
  filteredStudentsLength: student.filteredStudentsLength,
  classrooms: home.classrooms,
  departments: home.departments,
  courses: home.courses,
  electives: home.electives,
  isHigherEducationInstitute: home.isHigherEducationInstitute,
  isLocked: home.isLocked,
  userDetails: auth.userDetails,
  institutesTags: home.institutesTags,
  institutesTags: home.institutesTags,
  institutesTagGroups: home.institutesTagGroups,
  totalFeeDue: student.totalFeeDue,
  totalFeePaid: student.totalFeePaid,
  exportStudents: student.exportStudents,
});

export default withRouter(
  connect(mapStateToProps, {
    getStudentList,
    createNewStudent,
    updateCurrentStudentData,
    getMembershipDetails,
  })(StudentList)
);
